import React from "react";
import { Router } from "react-router-dom";
import { createBrowserHistory } from "history";
import { ThemeProvider, CssBaseline } from "@material-ui/core";
import Routes from "src/Routes";
import theme from "src/theme";
import ModalProvider from "./components/ModalProvider";
import PDPACookie from "./components/PDPACookie";
import Auth from "./components/Auth";
import {
  createHttpLink,
  InMemoryCache,
  ApolloClient,
  ApolloLink,
} from "@apollo/client";
import { ApolloProvider } from "@apollo/react-hooks";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error"; //add apollo error link

import GraphQLMock from "src/mock/GraphQLMock";
import Page from "src/components/Page";
import { routesConfig } from "src/Routes/config";
import RouteProp from "src/Routes/interface";

import { GQL_URI } from "src/config";
import MultiBrokerVerify from "./components/MultiBrokerManager";
import MaintenanceChecker from "./components/MaintenanceChecker";
import AxiosMock from "./mock/axiosMock";

const exceptUrl_401: Array<string> = [];

const makeExceptionURL = (route: Array<RouteProp>) => {
  route.forEach((route) => {
    if (route.routes && route.routes?.length !== 0) {
      makeExceptionURL(route.routes);
    } else if (!route.guard && route.path) {
      exceptUrl_401.push(`${route.path}`);
      exceptUrl_401.push(`${route.path}/`);
    } else if (route.guard && route.guard.name !== "AuthGuard" && route.path) {
      exceptUrl_401.push(route.path);
    }
  });
};

// routesConfig.forEach((route) => {
//   console.log(route.path,route.path)
//   if (!route.guard && route.path) {
//     exceptUrl_401.push(`${route.path}`);
//     exceptUrl_401.push(`${route.path}/`);
//   } else if (route.guard && route.guard.name !== "AuthGuard" && route.path) {
//     exceptUrl_401.push(route.path);
//   }
// });
makeExceptionURL(routesConfig);

const httpLink = createHttpLink({
  uri: GQL_URI,
  credentials: "include",
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    // graphQLErrors.map(({ message, locations, path }) =>
    // console.log(
    //         `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
    // ));
  }

  if (networkError) {
    // console.log(`[Network error]: ${networkError}`);
    var res_status = networkError.message.split(" ").slice(-1)[0];
    // console.log(networkError, res_status);
    if (res_status === "401") {
      exceptUrl_401.includes(window.location.pathname)
        ? void 0
        : (window.location.pathname = "/");
    }
  }
});

const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      // authorization: `JWT ${localStorage.getItem("accessToken")}`,
    },
  };
});

// const link = ApolloLink.from([errorLink,retryLink,authLink.concat(httpLink)])
const link = ApolloLink.from([errorLink, authLink.concat(httpLink)]);

const client = new ApolloClient({
  cache: new InMemoryCache(),
  // link: (authLink.concat(httpLink)).concat(errorLink),
  link: link,
});

function App() {
  const history = createBrowserHistory();

  return (
    <ThemeProvider theme={theme}>
      <MaintenanceChecker>
        <ApolloProvider client={client}>
          <CssBaseline />
          <Router history={history}>
            <GraphQLMock>
              <AxiosMock>
                <MultiBrokerVerify>
                  <Auth>
                    <ModalProvider>
                      <PDPACookie>
                        <Page title={"Finnize"}>
                          <Routes />
                        </Page>
                      </PDPACookie>
                    </ModalProvider>
                  </Auth>
                </MultiBrokerVerify>
              </AxiosMock>
            </GraphQLMock>
          </Router>
        </ApolloProvider>
      </MaintenanceChecker>
    </ThemeProvider>
  );
}

export default App;
